import PropTypes from 'prop-types';
import React from 'react';
import RosettaFormattedMessage from '../../common/rosetta_formatted_message';
import { sendAnalyticsEvent } from '../../../utils/analytics';
import truncateHtml from '../../../utils/truncateHtml';
import { link_target, link_rel } from '../../../utils/external_links';
import {map, unEscape, get} from 'lodash';

const AUTHOR_MAX_LENGTH = 20;

const contributorLabel = (display_name) => (
  <div className="contributor-label">
    <RosettaFormattedMessage parentFilename={__filename}
      id="byline"
      description="Author label that appears on standard cards"
      defaultMessage="by {name}"
      values={{
        name: (
          <span className="author-name"
            dangerouslySetInnerHTML={{ __html: truncateHtml(
              display_name,
              { length: AUTHOR_MAX_LENGTH, omission: '...' }
            ) }}
          />
        )
      }}
    />
  </div>
);

const handleClick = (id) => () => sendAnalyticsEvent(
  'Shopping',
  'Featured In Stories',
  id,
  { nonInteraction: false }
);

const FeaturedInModule = ({ entries }) => (
  <div className="featured-in-container">
    <div className="featured-in-header">
      <RosettaFormattedMessage parentFilename={__filename}
        id="featured_message"
        description="Message displayed in featured in module header"
        defaultMessage={`{
          entryCount,
          plural,
          one {Featured in 1 story}
          other {Featured in {entryCount} stories}
        }`}
        values={{ entryCount: entries.length }}
      />
    </div>
    {
      map(entries, (entry, i) => (
        <div className="featured-in-entry-container" key={i}>
          <a href={entry.url} target={link_target(entry.url)} rel={link_rel(entry.url)} onClick={handleClick(entry.id)}>
            <div className="featured-in-title"
              dangerouslySetInnerHTML={{
                __html: unEscape(entry.truncated_short_title_80)
              }}
            />
            {contributorLabel(get(entry, 'contributors[0].display_name'))}
          </a>
        </div>
      ))
    }
  </div>
);

FeaturedInModule.propTypes = {
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      truncated_short_title_80: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      meta: PropTypes.shape({
        sold_content_type: PropTypes.string
      }).isRequired,
      contributors: PropTypes.arrayOf(
        PropTypes.shape({
          display_name: PropTypes.string
        })
      )
    })
  ).isRequired
};

export default FeaturedInModule;
